<template>
  <div class="fit flex flex-col gap-1 overflow-hidden" ref="main">
    <div class="w-full flex">
      <div class="font-bold text-sm">{{ ui[data].title }}</div>
      <q-icon
        name="help"
        size="18px"
        color="black"
        class="ml-2"
        v-if="data == 'notification'"
      >
        <q-tooltip content-class="bg-black"> How To Setup </q-tooltip>
        <q-menu>
          <div style="width: 400px" class="p-4">
            <p class="text-sm">
              Setup <b>Notification Channels</b> to receive reminders in your
              preferred apps. Push Notifications are turned ON by DEFAULT.
            </p>
            <span class="font-bold">How to Receive Telegram Notifications</span>
            <ul class="text-sm">
              <li>
                1. Click to Send message to our
                <a href="https://t.me/Igeotechgps_bot" target="_blank"
                  >Igeotechgps Telegram account</a
                >
              </li>
              <li>
                2. COPY & PASTE the Chat ID received in the details section.
              </li>
              <li>
                3. If need assistance text us as
                <a
                  :href="
                    'https://api.whatsapp.com/send?phone=' +
                    userInfo.help_whatsapp +
                    '&text=Hi%20Igeotechgps%20Support!'
                  "
                  target="_blank"
                  >Igeotechgps Support</a
                >
              </li>
            </ul>
          </div>
        </q-menu>
      </q-icon>
      <q-space />
      <div class="flex gap-1 flex-center">
        <q-btn
          v-if="!['history'].includes(data)"
          color="primary"
          icon="add"
          :label="`Add New ${ui[data].add.text}`"
          no-caps
          padding="xs sm"
          dense
          class="text-xs"
          @click="addRow()"
        />
      </div>
    </div>
    <div class="flex-1 overflow-hidden" style="container-type: size">
      <q-table
        :data="currentData"
        style="max-height: 100cqh"
        dense
        hide-bottom
        flat
        :rows-per-page-options="[0]"
        :columns="ui[data].columns"
      >
        <template #header="props">
          <q-tr
            :props="props"
            style="position: sticky; top: 0; z-index: 999"
            class="bg-white"
          >
            <q-th
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              style="z-index: 999"
            >
              <span class="font-bold capitalize text-xs">
                {{ col.label }}
              </span>
            </q-th>
            <q-th class="font-bold capitalize text-center" key="action">
              Actions
            </q-th>
          </q-tr>
        </template>

        <template #body="props">
          <q-tr :props="props">
            <q-td
              v-for="col in props.cols"
              :key="col.field"
              :props="props"
              :class="{ 'pointer-events-none': ['history'].includes(data) }"
            >
              <!-- notification -->
              <FuseSelect
                v-if="['type'].includes(col.field)"
                v-model="props.row[col.name]"
                style="width: 70px; max-height: 40px"
                class="flex h-6"
                :options="ui[data].options.type"
              />
              <q-select
                v-if="['mode'].includes(col.field)"
                v-model="props.row[col.name]"
                dense
                outlined
                multiple
                class="mode"
                placeholder="Select"
                style="width: 100px; max-height: 50px"
                :input-style="{ backgroundColor: 'red' }"
                :options="['All', 'Service', 'Document', 'Tire']"
              >
                <template #selected="scope">
                  <div v-if="props.row[col.name].length == 0" class="text-grey">
                    Select Mode
                  </div>
                  <div v-if="props.row[col.name].length == 1">
                    {{ props.row[col.name][0] }}
                  </div>
                  <div v-if="props.row[col.name].length > 1">
                    {{ props.row[col.name].length }} Selected
                  </div>
                </template>
              </q-select>
              <vs-input
                size="small"
                clearable
                v-model="props.row[col.name]"
                v-if="col.field == 'detail'"
                style="width: 120px"
              />
              <textarea
                v-if="col.field == 'remark'"
                v-model="props.row[col.name]"
                class="text-xs"
                style="width: 120px; max-height: 40px; min-height: 30px"
              />
              <!-- documents -->
              <!-- <FuseSelect
                v-if="['name'].includes(col.label)"
                v-model="props.row[col.name]"
                style="width: 70px"
                class="flex"
                :options="ui[data].options.name"
              /> -->
              <input
                v-if="col.field == 'date'"
                type="date"
                v-model="props.row[col.name]"
                class="w-full"
              />
              <Uploader
                ref="uploader"
                v-if="col.name == 'documents'"
                style="border: 1.5px dashed #00000066"
                class="fit rounded flex gap-1 justify-start items-center p-1 text-sm text-center cursor-pointer uploader duration-500"
                @success="
                  (v) => {
                    updateProfile(v, props.row[col.field]);
                  }
                "
              >
                <q-avatar
                  size="25px"
                  class="relative"
                  square
                  v-for="(file, i) in listDocuments(props.row[col.field])"
                >
                  <a
                    :href="`https://api.igeotechgps.com/uploads/${file.link}`"
                    target="_blank"
                    class="fit"
                  >
                    <img
                      v-if="images.includes(file.type)"
                      :src="`https://api.igeotechgps.com/uploads/${file.link}`"
                      :alt="file.name" />
                    <div
                      v-else
                      class="fit flex flex-center items-center"
                      style="
                        border-right: solid 1px rgb(234, 234, 234);
                        background: #e5f1ff;
                      "
                    >
                      <q-icon
                        name="insert_drive_file"
                        color="primary"
                        size="25px"
                      /></div
                  ></a>

                  <q-tooltip content-class="bg-black">
                    {{ file.name }}</q-tooltip
                  >
                  <q-btn
                    class="absolute top-0 right-0 z-10 remove duration-200"
                    size="10px"
                    color="danger"
                    icon="delete"
                    flat
                    rounded
                    padding="none"
                    style="transform: translate(50%, -50%)"
                    @click="removeDocument(props.row[col.field], i)"
                  >
                    <!-- <q-tooltip
                      content-class="bg-black"
                      anchor="top middle"
                      self="top start"
                    >
                      Remove {{ file.name }}
                    </q-tooltip> -->
                  </q-btn>
                </q-avatar>
                <q-btn
                  color="primary"
                  icon="add"
                  padding="xs xs"
                  dense
                  class="text-xs ml-auto"
                  @click="openFile"
                >
                  <q-tooltip content-class="bg-black"> Upload files </q-tooltip>
                </q-btn>
              </Uploader>

              <div
                class="fit bg- flex flex-center gap-1"
                v-if="['cost', 'mileage'].includes(col.field)"
              >
                <fuse-select
                  class="w-16 h-6"
                  :class="{
                    'flex-1':
                      !props.row.mileageOnce ||
                      props.row.mileageOnce == 'Recurring',
                  }"
                  v-if="col.field == 'mileage'"
                  v-model="props.row.mileageOnce"
                  :options="['Once', 'Recurring']"
                  placeholder="Select Mileage Type"
                  outline
                  dense
                />
                <vs-input
                  v-if="
                    (col.field == 'mileage' &&
                      props.row.mileageOnce == 'Once') ||
                    col.field == 'cost'
                  "
                  class="flex-1"
                  type="number"
                  size="small"
                  :min="0"
                  v-model.number="props.row[col.name]"
                />
                <fuse-select
                  class="w-12 h-6"
                  v-if="
                    col.field == 'mileage' && props.row.mileageOnce == 'Once'
                  "
                  v-model="props.row.mileageOnceType"
                  :options="['Exact', 'Recurring Every']"
                  placeholder="Please Select"
                  outline
                  dense
                />
              </div>
            </q-td>
            <q-td
              class="font-bold capitalize text-center"
              key="action"
              style="width: 20px"
            >
              <!-- {{ props }} -->
              <q-btn
                color="success"
                icon="done"
                flat
                padding="none"
                v-if="['documents', 'engine', 'tyre'].includes(data)"
                @click="completed(props.rowIndex)"
              >
                <q-tooltip content-class="bg-black">
                  Mark document as completed {{ props.rowIndex }}
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="![].includes(data)"
                color="danger"
                icon="delete"
                flat
                padding="none"
                @click="removeRow(props.rowIndex)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { store, template } from '../../api/api';
import { useElementHover } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router/composables';

import FuseSelect from '@/components/custom-ui/FuseSelect.vue';
import vSelect from 'vue-select';
import Uploader from './Uploader.vue';

const userInfo = JSON.parse(localStorage.getItem('userInfo'));

const props = defineProps(['data', 'tyre']);

const emit = defineEmits(['add', 'remove']);

const route = useRoute();
const main = ref();

const ui = {
  notification: {
    title: 'Notification Channels',
    columns: [
      { label: 'Type', ...baseColumn('type') },
      { label: 'Detail', ...baseColumn('detail') },
      { label: 'Mode', ...baseColumn('mode') },
      { label: 'Remarks', ...baseColumn('remark') },
    ],
    options: {
      type: ['Telegram', 'Email'],
    },
    add: {
      text: 'Channel',
      t: template.notification,
    },
  },
  documents: {
    title: 'Documents',
    columns: [
      { label: 'Name', ...baseColumn('type') },
      { label: 'Expiry [Date]', ...baseColumn('date') },
      { label: 'Documents', ...baseColumn('documents') },
      { label: 'Cost [RM]', ...baseColumn('cost') },
      { label: 'Remarks', ...baseColumn('remark') },
    ],
    add: {
      text: 'Document',
      t: template.documents,
    },
    options: {
      type: ['Road Tax', 'Permit', 'Puspakom', 'Summons', 'Insurance'],
    },
  },
  history: {
    title: 'History',
    columns: [
      { label: 'Type', ...baseColumn('type') },
      { label: 'Date', ...baseColumn('date') },
      { label: 'Documents', ...baseColumn('documents') },
      { label: 'Cost [RM]', ...baseColumn('cost') },
      { label: 'Remarks', ...baseColumn('remark') },
    ],
    add: {
      text: 'History',
      t: template.history,
    },
    options: {
      type: ['Road Tax', 'Permit', 'Puspakom', 'Summons', 'Insurance'],
    },
  },
  engine: {
    title: 'Engine',
    columns: [
      { label: 'Type', ...baseColumn('type') },
      { label: 'Expiry [Date]', ...baseColumn('date') },
      { label: 'Expiry [Mileage / KM]', ...baseColumn('mileage') },
      { label: 'Cost [RM]', ...baseColumn('cost') },
      { label: 'Documents', ...baseColumn('documents') },
      { label: 'Remarks', ...baseColumn('remark') },
    ],
    add: {
      text: 'Engine',
      t: template.engine,
    },
    options: {
      type: [
        'Engine oil & filter',
        'Transmission fluid levels',
        'Oil Pressure',
        'Cooling & heating systems',
        'Engine tune up',
        'Braking system',
        'Fuel System',
        'Mounts',
        'Drive shafts',
        'CV Joints',
        'Belts & Hoses',
        'Electrical systems & components',
        'Tires,wheels & rims',
        'Undercarriage',
        'Frame',
        'Steering & Suspension system',
        'Exhaust system',
        'Auxiliary vehicle systems',
        'Body,glass,mirrors,seat belts,seat structure',
        'Exterior & interior lights',
        'Change oil and oil filter',
        'Lubricate chassis,steering,suspension & driveline',
        'Check belts,hoses and fill fluid levels',
        'Drain fuel filter/water separator',
        'Rotate tires and adjust air pressure',
        'Check brakes',
        'Replace external fuel filters',
        'Inspect engine air filter restriction gauge and replace filter',
        'Replace cabin air filter',
        'Replace transfer case fluid',
        'Replace front and rear differential fluid',
        'Transmission Service',
        'Coolant replacement',
      ],
    },
  },
  tyre: {
    title: 'Reminders',
    columns: [
      { label: 'Reminder [Date]', ...baseColumn('date') },
      { label: 'Reminder [Mileage / KM]', ...baseColumn('mileage') },
      { label: 'Cost [RM]', ...baseColumn('cost') },
      { label: 'Remarks', ...baseColumn('remark') },
    ],
    add: {
      text: 'Document',
      t: template.tyreReminders,
    },
  },
};

const currentData = computed(() => {
  let v = props.data;

  if (v == 'notification') {
    return store.state[v].channel;
  } else if (v == 'tyre') {
    return store.state[v][props.tyre].reminders;
  } else {
    // test data for history
    // if (v == 'history') {
    //   return [
    //     {
    //       cost: 50000,
    //       date: '1/2/3',
    //       type: 'Test',
    //       remark: 'hello',
    //       documents: [],
    //     },
    //   ];
    // }
    return store.state[v];
  }
});
function addRow() {
  store.addRow(currentData.value, ui[props.data].add.t);
  // console.log(currentData.value, ui[props.data].add.t);
  emit('add');
}

function removeRow(i) {
  store.removeRow(currentData.value, i);
  // emit('remove');
}

async function completed(i) {
  let row = currentData.value[i];
  row.type = props.data;
  if (row.type == 'tyre') {
    row.tyrePosition = props.tyre;
  }
  row.completed = getUTC();
  if (!store.data.fleetDetails.fleetRecordHistory) {
    store.data.fleetDetails.fleetRecordHistory = [];
  }
  store.data.fleetDetails.fleetRecordHistory.push(row);
  removeRow(i);
  await store.updateData(route.query.asset, main.value);
}

function getUTC() {
  let currentDate = new Date();
  return currentDate.toISOString().slice(0, 19).replace('T', ' ');
}

function baseColumn(v) {
  return { name: v, field: v, align: 'left', sortable: true };
}

function listDocuments(arr) {
  let array = [];
  if (arr) {
    arr.forEach((e) => {
      array.push(getFileName(e));
    });
  }
  return array;
}

function getFileName(str) {
  let arr = str.split('_');
  return {
    name: arr.slice(3).join(''),
    type: arr.at(-1).split('.')[1],
    link: str,
  };
}

const images = ['jpg', 'jpeg', 'png', 'svg'];

const uploader = ref();
function openFile() {
  console.log(uploader.value[0]._setupState.open());
}

async function updateProfile(v, state) {
  state.push(v);
  await store.updateData(route.query.asset, main.value);
}
async function removeDocument(state, i) {
  state.splice(i, 1);
  await store.updateData(route.query.asset, main.value);
}
</script>

<style>
.mode .q-field__inner {
  padding: 0;
}

.mode .q-field__native.row.items-center {
  gap: 4px;
}
.mode .q-field__native > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.mode .q-field__control.relative-position.row.no-wrap {
  /* padding-top: 4px;
  padding-bottom: 4px; */
  padding: 4px 8px;
}

.mode .q-field__control,
.mode .q-field__marginal {
  height: 24px;
  font-size: 12px;
}
.mode
  .q-field__append.q-field__marginal.row.no-wrap.items-center.q-anchor--skip {
  height: 100% !important;
}
.remove:hover {
  background: black;
}
</style>

<style lang="scss">
.mode.q-field--dense {
  .q-field__control-container {
    height: 100% !important;
    align-items: center;
  }
  .q-field__native {
    padding-top: 0px !important;
    height: 32px !important;
  }

  .q-field__control {
    height: 32px !important;
    min-height: 32px !important;
  }

  .q-field__marginal {
    height: 32px !important;
  }
}
</style>
